import CreateBracketApp from "./CreateBracketApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(CreateBracketApp);
